<template>
  <div class="hello" style="margin-top:40px">
    <img alt="App logo" src="../assets/logo.png" height="64px" width="64px" />
    <br />
    <h1>Track User</h1>
    <br />
    <div class="w-25 mx-auto">
      <b-form-group
        id="fieldset-1"
        label="Username"
        label-for="input-username"
        :invalid-feedback="invalidFeedbackUsername"
        :valid-feedback="validFeedbackUsername"
        :state="stateUsername"
      >
        <b-form-input id="input-username" v-model="username" :state="stateUsername" trim></b-form-input>
      </b-form-group>
      <b-form-group
        id="fieldset-2"
        label="Live Track Password"
        label-for="input-password"
        :invalid-feedback="invalidFeedbackPassword"
        :valid-feedback="validFeedbackPassword"
        :state="statePassword"
      >
        <b-form-input
          id="input-password"
          type="password"
          v-model="password"
          :state="statePassword"
          trim
        ></b-form-input>
      </b-form-group>

      <b-button block variant="primary" v-on:click="clickTrackUser">Track User</b-button>
    </div>

    <b-modal id="insp" title="Informação">
      <p class="my-4">Live Track not available</p>
    </b-modal>

    <b-modal id="terminado" title="Informação">
      <p class="my-4">Live Track mode end</p>
    </b-modal>
  </div>
</template>


<script>
import firebase from "firebase";
export default {
  name: "SearchUser",
  computed: {
    stateUsername() {
      return this.username.length >= 1 ? true : false;
    },
    statePassword() {
      return this.password.length >= 1 ? true : false;
    },
    invalidFeedbackUsername() {
      if (this.username.length > 1) {
        return "";
      } else if (this.username.length > 0) {
        return "Enter at least 1 characters";
      } else {
        return "";
      }
    },
    validFeedbackUsername() {
      return this.state === true ? "Thank you" : "";
    },
    invalidFeedbackPassword() {
      if (this.password.length > 1) {
        return "";
      } else if (this.password.length > 0) {
        return "Enter at least 1 characters";
      } else {
        return "";
      }
    },
    validFeedbackPassword() {
      return this.state === true ? "Thank you" : "";
    }
  },
  methods: {
    async clickTrackUser() {
      let rootRef = firebase.database().ref();
      let query = rootRef.child("users");
      await query.once("value", snapshot => {
        snapshot.forEach(user => {
          if (
            user.val().email === this.username &&
            user.val().live_track_password === this.password &&
            user.val().activity_running === true
          ) {
            console.log("User a dar track");
            console.log(user.key);
            //mudar aqui para a nova rota com o uid do user
            this.validoTrack = true;
            this.$router.push({
              name: "track",
              params: {
                uuid: user.key
              }
            });
            return;
          }
        });
      });

      if (!this.validoTrack) {
        this.$bvModal.show("insp");
      }
    }
  },
  data() {
    return {
      username: "",
      password: "",
      validoTrack: false
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
